import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { homeForRole } from "@/lib/authUtils";
import BrandLoader from "@/components/feature/BrandLoader";

export default function RootRedirect() {
  const { session, profile, roleName, loading } = useAuth();

  if (loading) return <BrandLoader label="Iniciando Sistema RKC..." />;

  if (!session || !profile) return <Navigate to="/login" replace />;

  return <Navigate to={homeForRole(roleName)} replace />;
}